<template>
	<section class="will-change" data-scroll-section>
		<!-- hero img -->
		<div class="hero w-full relative overflow-hidden">
			<div class="xl:px-content pt-[96px] xl:pt-[180px]">
				<img
					class="object-cover w-full h-auto"
					v-show="fieldsData.image && !isToponym"
					:src="fieldsData.image.sizes.eventhero"
					:alt="fieldsData.image.alt"
				/>
			</div>
		</div>
		<!-- ./hero img -->

		<div
			class="mx-auto px-content xl:py-9 xl:w-8/12"
			:class="{ 'pt-10 pb-4 md:pt-16': isToponym, 'py-4': !isToponym }"
		>
			<div
				v-show="!isToponym"
				class="flex items-center justify-between text-navy-blue-03"
			>
				<time
					class="flex items-center"
					:datetime="formatDate(postData.post_date)"
				>
					<img
						class="mr-5"
						v-show="postData.post_date"
						:src="
							this.endpoints.template_url +
							'/assets/img/calendar-icon-black.svg'
						"
						:alt="'calendar-icon'"
					/>
					<span
						class="text-sm tracking-desk"
						v-show="postData.post_date"
						v-html="formatDate(postData.post_date)"
					></span>
				</time>
			</div>
			<hr v-show="!isToponym" class="border-light-grey my-4 xl:mt-9 xl:mb-14" />
			<p class="breadcrumbs mb-4 xl:mb-9">
				<a class="breadcrumbs-link" :href="homeUrl">{{
					breadcrumbData[language]?.homepage
						? breadcrumbData[language]?.homepage
						: "Home"
				}}</a
				><span> > </span
				><a
					class="breadcrumbs-link"
					:href="
						isToponym
							? breadcrumbData[language].toponymLink
							: breadcrumbData[language].blogLink
					"
					>{{
						isToponym
							? breadcrumbData[language].toponymTitle
							: breadcrumbData[language].blogTitle
					}}</a
				><span> > </span><span>{{ postData.post_title }}</span>
			</p>
			<h1
				class="text-4xl xl:text-heading font-light"
				v-show="postData.post_title"
			>
				{{ postData.post_title }}
			</h1>
		</div>
	</section>
</template>

<script>
import { format, parse } from "date-fns";
export default {
	name: "HeroDefaultPost",
	data() {
		return {
			isToponym: false,
			homeUrl: "",
			language: document.documentElement.lang || "en",
			breadcrumbData: {
				en: {
					blogLink: "/news-and-blog-lustica-bay/",
					blogTitle: "Blog",
					toponymLink: "/sights-of-montenegro-lustica-bay/",
					toponymTitle: "Toponym",
				},
				"de-DE": {
					blogLink: "/de/blog/",
					blogTitle: "Blog",
					toponymLink: "/de/sights-of-montenegro/",
					toponymTitle: "Toponym",
				},
				"ru-RU": {
					homepage: "Главная",
					blogLink: "/ru/blog/",
					blogTitle: "Блoг",
					toponymLink: "/ru/sights-of-montenegro/",
					toponymTitle: "Топоним",
				},
				"sr-ME": {
					blogLink: "/me/blog/",
					blogTitle: "Blog",
					toponymLink: "/me/sights-of-montenegro/",
					toponymTitle: "Toponim",
				},
			},
		};
	},
	mounted() {
		if (document.querySelector("body").classList.contains("single-toponym")) {
			this.isToponym = true;
		}

		if (document.documentElement.lang.split("-")[0] === "en") {
			this.homeUrl = window.location.origin;
		} else if (document.documentElement.lang.split("-")[0] === "sr") {
			this.homeUrl = `${window.location.origin}/me`;
		} else {
			this.homeUrl = `${window.location.origin}/${
				document.documentElement.lang.split("-")[0]
			}`;
		}
	},
	methods: {
		formatDate(date) {
			let parsed = parse(date, "yyyy-MM-dd HH:mm:ss", new Date());
			let formated = format(parsed, "dd MMM yyyy");
			return formated;
		},
	},
};
</script>
